// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3N9hm","disclaimer":"styles_disclaimer__BrBBa"};